// Utility function to check browser support for Firebase Messaging
export const checkFirebaseMessagingSupport = (): boolean => {
  // Check for basic requirements
  if (typeof window === 'undefined') return false;

  // Check for Service Worker support
  if (!('serviceWorker' in navigator)) {
    console.warn('Service Worker is not supported in this browser');
    return false;
  }

  // Check for Push Manager support
  if (!('PushManager' in window)) {
    console.warn('Push Manager is not supported in this browser');
    return false;
  }

  // Check for Notification support
  if (!('Notification' in window)) {
    console.warn('Notifications are not supported in this browser');
    return false;
  }

  // Check for basic Web API support required by Firebase
  if (!('indexedDB' in window)) {
    console.warn('IndexedDB is not supported in this browser');
    return false;
  }

  return true;
};

// Check if the browser is known to have issues with Firebase Messaging
export const isUnsupportedBrowser = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();

  // Check for browsers that don't support Firebase Messaging
  const unsupportedBrowsers = ['opera mini', 'ucbrowser', 'samsung', 'miui', 'webview'];

  return unsupportedBrowsers.some((browser) => userAgent.includes(browser));
};

// Get browser info for debugging
export const getBrowserInfo = () => ({
  userAgent: navigator.userAgent,
  hasServiceWorker: 'serviceWorker' in navigator,
  hasPushManager: 'PushManager' in window,
  hasNotification: 'Notification' in window,
  hasIndexedDB: 'indexedDB' in window,
  notificationPermission: 'Notification' in window ? Notification.permission : 'not-supported',
});
